import { computed, inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VoiceFlowStateService } from '../voice-flow-state.service';
import { VoiceAdditionalOfferData } from '../../../../../../../models/order/workflow/voice/voice-flow.model';
import { VoiceProductResponseService } from '../../../order-api-response/voice-pd-response.service';
import { AdditionalOfferData } from '../../../../../../../models/order/workflow/additional-offer.model';

@Injectable({ providedIn: 'root' })
export class AdditionalVoiceOffersStateService extends BaseWorkflowStateService<VoiceAdditionalOfferData> {
    private flowStateService = inject(VoiceFlowStateService);
    private voicePdResponseService = inject(VoiceProductResponseService);
    override stateKey: string = 'voiceOffers';

    includedOfferCustomizations = computed(() => {
        this.voicePdResponseService.getCustomizations(); // track PD response changes
        return this.voicePdResponseService.getIncludedOffersCustomizations();
    });

    offers = computed(() => this.state()?.offers ?? []);

    getDefaultIncludedOffers(): AdditionalOfferData[] {
        return this.voicePdResponseService.getDefaultSelectedChoices();
    }

    protected override saveLocalDraft(): void {
        // Merge, so directory/porting offers written by voice configuration are preserved.
        this.flowStateService.updateData({
            voiceOffers: { offers: this.flowStateService.mergeVoiceOffers(this.state()?.offers ?? []) }
        });
    }
}
